"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const lucide_vue_next_1 = require("lucide-vue-next");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const axios_1 = __importDefault(require("axios"));
const EventTracker_1 = __importDefault(require("@becrop/abstract/Utils/EventTracker"));
const lucide_vue_next_2 = require("lucide-vue-next");
const MapBmkController_1 = __importDefault(require("@becrop/components/MapBmk/MapBmkController"));
const MapLayer_1 = __importDefault(require("@becrop/components/MapBmk/models/MapLayer"));
let QuoteLinkerModal = class QuoteLinkerModal extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.ButtonStates = {
            ENABLED: 'enabled',
            DISABLED: 'disabled',
            LOADING: 'loading',
        };
        this.eventTracker = new EventTracker_1.default();
        this.associatedGisArea = null;
        this.associationSuccessful = false;
        this.showResponse = false;
        this.responseMessage = '';
        this.assocButtons = [];
        this.importWholeFarmButtons = [];
        this.editQuoteButtons = [];
        this.quoteSelected = null;
        this.activeQuote = null;
        // *********** NEW MAP CONFIG ***************
        this.mapLayer = new MapLayer_1.default({
            provider: this.map_config.provider,
            key: this.map_config.apikey,
        });
        this.mapBmkController = new MapBmkController_1.default(this.mapLayer, 'map-farm-list');
    }
    get quoteOptions() {
        return this.pendingAssociationQuotes.map((q) => {
            return {
                label: q.farm_name,
                value: q.quote_id,
                quote_ext: q.quote_extension,
                farm_ext: q.farm_extension,
                unit: this.shortPreferredUnit(q.preferred_unit)
            };
        });
    }
    get defaultQuote() {
        return this.quoteOptions.find((q) => q.value === this.pendingAssociationQuotes[0].quote_id);
    }
    shortPreferredUnit(preferredUnit) {
        if (preferredUnit === 'hectares') {
            return 'ha';
        }
        else if (preferredUnit === 'acres') {
            return 'ac';
        }
        return preferredUnit;
    }
    updateQuoteSelected(model) {
        this.quoteSelected = model;
        this.changeQuoteSelected();
    }
    changeQuoteSelected() {
        this.activeQuote = this.pendingAssociationQuotes.find((q) => q.quote_id === this.quoteSelected.value);
        this.drawFarm();
    }
    dismissModal() {
        if (this.associatedGisArea === null) {
            this.$emit('dismissModal');
        }
        else {
            //this.$emit('dismissModal');
            //this.jumpToMap();
            window.location.reload();
        }
    }
    async associateGisArea(farmId, quoteId, wholeFarm = false) {
        const data = {
            quote_id: quoteId,
            gis_area_id: this.activeGisAreaId,
            whole_farm: wholeFarm
        };
        const response = await this.associate(data, farmId);
        this.responseMessage = response.messages;
        this.showResponse = true;
        if (response.status === 200) {
            this.associatedGisArea = this.activeGisAreaId;
            this.associationSuccessful = true;
        }
    }
    async associate(data, farmId) {
        var _a, _b, _c, _d;
        this.disableAllButtons();
        if (data.whole_farm) {
            this.importWholeFarmButtons[`${farmId}-${data.quote_id}`] = this.ButtonStates.LOADING;
        }
        else {
            this.assocButtons[`${farmId}-${data.quote_id}`] = this.ButtonStates.LOADING;
        }
        try {
            const url = '/farm-quoting/associate-gis-area';
            const response = await axios_1.default.post(url, data);
            return {
                status: response.data.status,
                messages: response.data.messages,
            };
        }
        catch (error) {
            console.error(error);
            return {
                status: ((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.status) || 500,
                messages: ((_d = (_c = error.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.messages) || 'Unknown error',
            };
        }
        finally {
            this.enableAllButtons();
        }
    }
    editQuote(farmId) {
        window.location.href = `/farm/custom_quote?farmId=${farmId}&action=editQuote&proposal=${this.proposalId}`;
    }
    jumpToMap() {
        window.location.href = window.location.href + '&showingArea=' + this.associatedGisArea;
    }
    eventTrackerListener(eventName, data) {
        this.eventTracker.trackEvent(eventName, data);
    }
    disableAllButtons() {
        for (const key in this.assocButtons) {
            this.assocButtons[key] = this.ButtonStates.DISABLED;
        }
        for (const key in this.importWholeFarmButtons) {
            this.importWholeFarmButtons[key] = this.ButtonStates.DISABLED;
        }
        for (const key in this.editQuoteButtons) {
            this.editQuoteButtons[key] = this.ButtonStates.DISABLED;
        }
    }
    enableAllButtons() {
        for (const key in this.assocButtons) {
            this.assocButtons[key] = this.ButtonStates.ENABLED;
        }
        for (const key in this.importWholeFarmButtons) {
            this.importWholeFarmButtons[key] = this.ButtonStates.ENABLED;
        }
        for (const key in this.editQuoteButtons) {
            this.editQuoteButtons[key] = this.ButtonStates.ENABLED;
        }
    }
    drawFarm() {
        var _a, _b, _c;
        if (this.activeQuote && this.activeQuote.geodata) {
            this.mapBmkController.drawParcel((_a = this.activeQuote) === null || _a === void 0 ? void 0 : _a.geodata, `${(_b = this.activeQuote) === null || _b === void 0 ? void 0 : _b.cropColor}50`, `${(_c = this.activeQuote) === null || _c === void 0 ? void 0 : _c.cropColor}`);
        }
    }
    mounted() {
        this.mapBmkController.create();
        this.drawFarm();
        this.assocButtons = this.pendingAssociationQuotes.reduce((btn, quote) => {
            const key = `${quote.farm_id}-${quote.quote_id}`;
            btn[key] = this.ButtonStates.ENABLED;
            return btn;
        }, {});
        this.importWholeFarmButtons = this.pendingAssociationQuotes.reduce((btn, quote) => {
            const key = `${quote.farm_id}-${quote.quote_id}`;
            btn[key] = this.ButtonStates.ENABLED;
            return btn;
        }, {});
        this.editQuoteButtons = this.pendingAssociationQuotes.reduce((btn, quote) => {
            const key = `${quote.farm_id}-${quote.quote_id}`;
            btn[key] = this.ButtonStates.ENABLED;
            return btn;
        }, {});
        this.quoteSelected = this.defaultQuote;
        this.changeQuoteSelected();
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], QuoteLinkerModal.prototype, "pendingAssociationQuotes", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: null })
], QuoteLinkerModal.prototype, "proposalId", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: null })
], QuoteLinkerModal.prototype, "activeGisAreaId", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], QuoteLinkerModal.prototype, "map_config", void 0);
QuoteLinkerModal = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Button: bmk_ui_framework_1.Button,
            Loading: bmk_ui_framework_1.Loading,
            Modal: bmk_ui_framework_1.Modal,
            Pencil: lucide_vue_next_1.Pencil,
            FolderInput: lucide_vue_next_2.FolderInput,
            Select: bmk_ui_framework_1.Select,
            CheckRoundedIcon: bmk_ui_framework_1.CheckRoundedIcon,
            XRoundedIcon: bmk_ui_framework_1.XRoundedIcon
        },
        emits: ['dismissModal'],
    })
], QuoteLinkerModal);
exports.default = QuoteLinkerModal;
